export const userHaveSpecificPermission = (user, permission) => {
    if (user && user.infos && Array.isArray(user.infos.specific_permissions) && user.infos.specific_permissions.indexOf(permission) != -1)
        return true;

    return false;
}
